import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addCartransfer } from '../api/cartransferService';

/**
 * Hook para crear cartransfers
 */
export function useCreateCartransfer() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: addCartransfer,
    onSuccess: (data) => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['cartransfers'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      return data;
    },
    onError: (error) => {
      console.error('Error creating cartransfer:', error);
    },
  });
} 